import { render, staticRenderFns } from "./add-edit-skill.vue?vue&type=template&id=b4d94d14&scoped=true&lang=html"
import script from "./add-edit-skill.vue?vue&type=script&lang=js"
export * from "./add-edit-skill.vue?vue&type=script&lang=js"
import style0 from "./add-edit-skill.vue?vue&type=style&index=0&id=b4d94d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d94d14",
  null
  
)

export default component.exports